import {Material} from '@domain/materials'
import {TableCell, Typography} from '@mui/material'

export const FuelsClassificationRow = ({material}: {material: Material}) => (
  <>
    <TableCell>
      <Typography variant="caption">{material.classification?.fuelType}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.fuelCategory}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.fuelSubCategory}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.formSize}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.processingDegree}</Typography>
    </TableCell>
  </>
)
